const React = require('react');
const {ConfigRouter} = require('../../../../../dumb/AdminHelpers/AdminConfigs');

const Methods = require('./components/Methods').default;
const Limits = require('./components/Limits');
const TrxProcessing = require('./components/TrxProcessing');
const RetailersFee = require('./components/RetailersFee');
const CustomersFee = require('./components/CustomersFee');
const Notifications = require('./components/Notifications');
const RollingReserve = require('./components/RollingReserve');

module.exports = ({userId}) => {
  return (
    <div className="mt34">
      <ConfigRouter
        userId={userId}
        links={[
          // {id: 'limits', title: 'Limits'},
          {id: 'trxProcessing', title: 'Transaction Processing'},
          {id: 'methods', title: 'Methods'},
          {id: 'rollingReserve', title: 'Rolling Reserve'},
          {id: 'retailersFee', title: 'Retailers Fee'},
          {id: 'customersFee', title: 'Customers Fee'},
          // {id: 'notification', title: 'Notifications'},
        ]}
        views={{
          methods: Methods,
          limits: Limits,
          trxProcessing: TrxProcessing,
          rollingReserve: RollingReserve,
          retailersFee: RetailersFee,
          customersFee: CustomersFee,
          notification: Notifications
        }}
      />
    </div>
  )
}
